import axios from 'axios'
import { Urls } from "../../../store/urls";

export const getMainCategoryRepo = (params) => {
    return axios({
        method: 'GET',
        url: Urls.GET_VIDEO_FILTER_API,
        params: params
    })
}

export const getVideoListingRepo = (params) => {
    return axios({
        method: 'GET',
        url: Urls.GET_VIDEO_LISTING_API,
        params: params
    })
}

export const getEntityTypeRepo = (params) => {
    return axios({
        method: 'GET',
        url: Urls.GET_VIDEO_FILTER_API,
        params: params
    })
}

export const getMainCategoryDropDownDataRepo = (params) => {
    return axios({
        method: 'GET',
        url: Urls.GET_VIDEO_FILTER_API,
        params: params
    })
}

export const getSubCategoryListRepo = (params) => {
    return axios({
        method: 'GET',
        url: Urls.GET_VIDEO_FILTER_API,
        params: params
    })
}

export const getEntityNameListRepo = (params) => {
    return axios({
        method: 'GET',
        url: Urls.GET_VIDEO_FILTER_API,
        params: params
    })
}

export const postVideoDataRepo = (data) => {
    return axios({
        method: 'POST',
        url: Urls.GET_VIDEO_LISTING_API,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const putVideoDataRepo = (id, data) => {
    return axios({
        method: "PUT",
        url: Urls.GET_VIDEO_LISTING_API + "/" + id + "/detail",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

export const putVideoKeywordMappingRepo = (id, data) => {
    return axios({
        method: "PUT",
        url: Urls.GET_VIDEO_LISTING_API + "/" + id + "/category-mapping",
        data: data,
    });
};

export const getVideoDetailRepo = (id, params) => {
    return axios({
        method: 'GET',
        url: Urls.GET_VIDEO_LISTING_API + "/" + id + "/detail",
        params: params
    })
}

export const getVideoKeywordMappingRepo = (id, params) => {
    return axios({
        method: 'GET',
        url: Urls.GET_VIDEO_LISTING_API + "/" + id + "/category-mapping",
        params: params
    })
}
export const getVideoTitleRepo = (params) => {
    return axios({
        method: 'GET',
        url: Urls.GET_VIDEO_LISTING_API ,
        params: params
    })
}